//import { Stack } from "@mui/material";
import cx from "classnames";
import React from "react";
// import { IoMdSwap } from "react-icons/io";

// import { STRADDLE } from "lib/legacy";
import "./Tab.css";

export default function Tab(props) {
  const { options, option, setOption, onChange, type = "block", className, optionLabels, tradeType } = props;
  const onClick = (opt) => {
    if (setOption) {
      setOption(opt);
    }
    if (onChange) {
      onChange(opt);
    }
  };

  return (
    <div className={cx("Tab", type, className)}>
      {options.map((opt, idx) => {
        const label = optionLabels && optionLabels[opt] ? optionLabels[opt] : opt;
        return (
          <React.Fragment key={opt}>
            <div
              className={cx("Tab-option", "muted", { active: opt === option })}
              onClick={() => onClick(opt)}
              key={opt}
            >
              {label}
            </div>
            {/*{idx !== options.length - 1 && tradeType && <div className="Tab-divider" />}*/}
          </React.Fragment>
        );
      })}
    </div>
  );
}
